
import { useSelector } from 'react-redux';
import './LastNotes.css';
import LastNotesCardBold from './LastNotesCardBold';
import { createLogger } from '../../../../../utils/logger';

const logger = createLogger('LastNotes');

interface LastNote {
  id:number;
  notebook:string;
  name:string;
  date:number | string;
}

const LastNotes = ({handleSelectNote}) => {

  // @ts-ignore
  const notes = useSelector((state) => state.notes.value);
  
    let data:LastNote[] = [];
    let lenNotes = notes.length;
    const defaultMaxSize = 6
    let autoSize = lenNotes > defaultMaxSize ? defaultMaxSize :lenNotes;
    if(notes !== undefined){
      data = notes.filter((_e,idx) => {return idx<autoSize}).map((e:any)=>{
         let name = e.name;
         if(e.name.length > 16){
           name = e.name.substring(0,16);
         }
         return {
           id:e.id,
           notebook:'',
           name:name,
           date:e.created
         }
       })
     }

     const onClickNote = async (note)=>{
       logger.debug(`click on ${note.id}`)
      handleSelectNote(note.id);
    };

    return (
      <>
      <div className="last-notes-container p-1 mb-1 rounded">
        <div className="last-notes-wrapper">
          {data.map((e)=>{
            return (
              <LastNotesCardBold
                key={`last-note-${e.id}`}
                id={e.id}
                name={e.name}
                date={e.date}
                onClick={() => onClickNote(e)}
              />
            )
          })}
        </div>
      </div>
      </>
    );
};

export default LastNotes;
